import React, { useEffect, useState } from 'react';
import { ControlIcon } from './CompactControls';

const STORAGE_KEY = 'jaosve.articleView';
const views = [
  { value: 'list', label: 'Lista', icon: 'list' },
  { value: 'small', label: 'Manje kartice', icon: 'grid-small' },
  { value: 'large', label: 'Veće kartice', icon: 'grid-large' },
];
const validView = value => views.some(view => view.value === value) ? value : 'small';

export function useArticleView() {
  const [view, setView] = useState(() => {
    try { return validView(localStorage.getItem(STORAGE_KEY)); }
    catch { return 'small'; }
  });
  useEffect(() => {
    const sync = event => {
      if (event.key === STORAGE_KEY || event.key === null) setView(validView(event.newValue));
    };
    window.addEventListener('storage', sync);
    return () => window.removeEventListener('storage', sync);
  }, []);
  const changeView = value => {
    const next = validView(value);
    setView(next);
    try { localStorage.setItem(STORAGE_KEY, next); } catch { /* View still works without storage. */ }
  };
  return [view, changeView];
}

export function ArticleViewPicker({ view, onChange }) {
  return <div className="article-view-picker" role="group" aria-label="Prikaz vijesti">
    {views.map(option => <button key={option.value} type="button" aria-pressed={view === option.value}
      onClick={() => onChange(option.value)} title={option.label}>
      <ControlIcon name={option.icon} /><span>{option.label}</span>
    </button>)}
  </div>;
}

export function ArticleGrid({ view, children }) {
  const [width, setWidth] = useState(() => window.innerWidth);
  useEffect(() => {
    const resize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, []);
  const count = view === 'list' ? 1 : view === 'large' ? (width <= 768 ? 1 : 2)
    : width <= 768 ? 2 : width <= 1024 ? 3 : 4;
  const columns = Array.from({ length: count }, () => []);
  // Preserve the original feed distribution, with each column stacking independently.
  React.Children.toArray(children).forEach((child, index) => columns[index % count].push(child));
  return <div className={`news-grid news-view-${view}`}>
    {columns.map((articles, index) => <div className="news-column" key={index}>{articles}</div>)}
  </div>;
}

export function ArticleImage({ src, loading = 'lazy' }) {
  const [failedSrc, setFailedSrc] = useState(null);
  if (!src || failedSrc === src) return null;
  return <div className="news-image"><img src={src} alt="" loading={loading} decoding="async"
    onError={() => setFailedSrc(src)} /></div>;
}
